import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=93143948&scoped=true&"
import script from "./approver.vue?vue&type=script&lang=js&"
export * from "./approver.vue?vue&type=script&lang=js&"
import style0 from "./approver.vue?vue&type=style&index=0&id=93143948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93143948",
  null
  
)

export default component.exports